$(document).ready(function initLinkify(){
    $('*[data-url]').click(handleClick)
})

function handleClick(e) {
    e.stopPropagation()
    window.location.href = $(this).data('url')
}